import { Link } from 'react-router-dom';
import { footerLinks, siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="mx-4 md:mx-6 mb-4 md:mb-6">
      <div className="bg-foreground-950 rounded-2xl px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <h3 className="text-3xl md:text-4xl font-heading font-light text-background-50 mb-4">
              51黑料吃瓜网
            </h3>
            <p className="text-sm text-foreground-300 leading-relaxed mb-8 max-w-md">
              {siteInfo.tagline}
            </p>
            <div className="max-w-sm">
              <label className="block text-xs font-medium text-foreground-400 mb-2 font-label uppercase tracking-wider">
                订阅最新爆料
              </label>
              <div className="flex border-b border-foreground-700 pb-2">
                <input
                  type="email"
                  placeholder="输入你的邮箱地址"
                  className="flex-1 bg-transparent text-sm text-background-50 placeholder-foreground-500 outline-none py-1"
                />
                <button className="text-background-50 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm font-medium ml-2">
                  订阅 <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-background-50 font-label uppercase tracking-wider mb-5">
              浏览分类
            </h4>
            <ul className="space-y-3">
              {footerLinks.explore.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 underline decoration-foreground-700 underline-offset-4"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2 md:col-start-8">
            <h4 className="text-xs font-semibold text-background-50 font-label uppercase tracking-wider mb-5">
              关于
            </h4>
            <ul className="space-y-3">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 underline decoration-foreground-700 underline-offset-4"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3 md:col-start-10">
            <h4 className="text-xs font-semibold text-background-50 font-label uppercase tracking-wider mb-5">
              联系方式
            </h4>
            <div className="space-y-3 text-sm text-foreground-400">
              <p>{siteInfo.phone}</p>
              <p>{siteInfo.email}</p>
              <div className="mt-5">
                <h4 className="text-xs font-semibold text-background-50 font-label uppercase tracking-wider mb-2">
                  地址
                </h4>
                <p className="leading-relaxed">{siteInfo.address}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a
              href={siteInfo.social.weibo}
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 underline decoration-foreground-700 underline-offset-4"
              rel="nofollow"
            >
              微博
            </a>
            <a
              href={siteInfo.social.douyin}
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 underline decoration-foreground-700 underline-offset-4"
              rel="nofollow"
            >
              抖音
            </a>
            <a
              href={siteInfo.social.xiaohongshu}
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 underline decoration-foreground-700 underline-offset-4"
              rel="nofollow"
            >
              小红书
            </a>
          </div>
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 51黑料吃瓜网 版权所有
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="#"
              className="text-xs text-foreground-400 hover:text-background-50 transition-colors duration-200 underline decoration-foreground-700 underline-offset-4"
            >
              用户协议
            </Link>
            <Link
              to="#"
              className="text-xs text-foreground-400 hover:text-background-50 transition-colors duration-200 underline decoration-foreground-700 underline-offset-4"
            >
              隐私政策
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}